<template>
  <div
    class="bonus-info"
    v-if="!hideBonusLabelB && bonusPartnerData && Object.keys(bonusPartnerData).length > 0"
  >
    <!-- max-cntent-area-->
    <div class="bonus-information">
      <h2 class="custom-font-1" v-if="bonusData.title && bonusData.title != ''">
        {{ bonusData.title }}
      </h2>
      <div class="cas-logo" :style="{ background: bonusPrimaryColour }">
        <a
          v-if="bonusPartnerData && bonusPartnerData.go_link"
          :title="bonusPartnerData.product_name"
          :href="getGoLink(bonusPartnerData.go_link, bonusPartnerData.slug)"
          class="partner-logo cas-link"
          target="_blank"
          :rel="
            $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
          "
        >
          <template v-if="assetsSize && assetsSize.pro_asset_sizes">
            <img
              v-if="$root.enable_lazyload"
              v-lazy="
                bonusPartnerData.product_assets.filter(
                  (ele) =>
                    ele.asset_category_name === assetsSize.pro_asset_sizes.large
                ).length > 0
                  ? bonusPartnerData.product_assets
                      .filter(
                        (ele) =>
                          ele.asset_category_name ===
                          assetsSize.pro_asset_sizes.large
                      )
                      .shift().url
                  : $root.site_url + $root.asset_path + '/failure.png'
              "
              height=""
              width=""
              :alt="
                getAltText(
                  bonusPartnerData.name,
                  bonusPartnerData.product_assets.filter(
                    (ele) =>
                      ele.asset_category_name ===
                      assetsSize.pro_asset_sizes.large
                  ).length > 0
                    ? bonusPartnerData.product_assets
                        .filter(
                          (ele) =>
                            ele.asset_category_name ===
                            assetsSize.pro_asset_sizes.large
                        )
                        .shift().url
                    : $root.site_url + $root.asset_path + '/failure.png'
                )
              "
            />
            <img
              v-else
              :src="
                bonusPartnerData.product_assets.filter(
                  (ele) =>
                    ele.asset_category_name === assetsSize.pro_asset_sizes.large
                ).length > 0
                  ? bonusPartnerData.product_assets
                      .filter(
                        (ele) =>
                          ele.asset_category_name ===
                          assetsSize.pro_asset_sizes.large
                      )
                      .shift().url
                  : $root.site_url + $root.asset_path + '/failure.png'
              "
              height=""
              width=""
              :alt="
                getAltText(
                  bonusPartnerData.name,
                  bonusPartnerData.product_assets.filter(
                    (ele) =>
                      ele.asset_category_name ===
                      assetsSize.pro_asset_sizes.large
                  ).length > 0
                    ? bonusPartnerData.product_assets
                        .filter(
                          (ele) =>
                            ele.asset_category_name ===
                            assetsSize.pro_asset_sizes.large
                        )
                        .shift().url
                    : $root.site_url + $root.asset_path + '/failure.png'
                )
              "
            />
            <div class="partner-hover wd-rev-bann">
              <div
                class="partner-hover-inner"
                :style="{
                  '--primary-btn': $root.color_schema.primary_btn,
                  '--primary-btn-hover': pSBC(
                    -0.2,
                    $root.color_schema.primary_btn
                  ),
                }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="16"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </template>
        </a>
        <template v-else>
          <template v-if="assetsSize && assetsSize.pro_asset_sizes">
            <img
              v-if="$root.enable_lazyload"
              v-lazy="
                bonusPartnerData.product_assets
                  .filter(
                    (ele) =>
                      ele.asset_category_name ===
                      assetsSize.pro_asset_sizes.large
                  )
                  .shift().url
              "
              height=""
              width=""
              :alt="
                getAltText(
                  bonusPartnerData.name,
                  bonusPartnerData.product_assets
                    .filter(
                      (ele) =>
                        ele.asset_category_name ===
                        assetsSize.pro_asset_sizes.large
                    )
                    .shift().url
                )
              "
            />
            <img
              v-else
              :src="
                bonusPartnerData.product_assets
                  .filter(
                    (ele) =>
                      ele.asset_category_name ===
                      assetsSize.pro_asset_sizes.large
                  )
                  .shift().url
              "
              height=""
              width=""
              :alt="
                getAltText(
                  bonusPartnerData.name,
                  bonusPartnerData.product_assets
                    .filter(
                      (ele) =>
                        ele.asset_category_name ===
                        assetsSize.pro_asset_sizes.large
                    )
                    .shift().url
                )
              "
            />
            <div class="partner-hover wd-rev-bann">
              <div
                class="partner-hover-inner"
                :style="{
                  '--primary-btn': $root.color_schema.primary_btn,
                  '--primary-btn-hover': pSBC(
                    -0.2,
                    $root.color_schema.primary_btn
                  ),
                }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="16"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </template>
        </template>
      </div>
      <span class="bonus-text custom-font-1">
        <template v-if="hideBonusLabelB">
          <span>{{ $root.i18n.hidden_partner_bonus }}</span>
        </template>
        <template v-else>
          <a
            :title="bonusPartnerData.product_name"
            :href="getGoLink(bonusPartnerData.go_link, bonusPartnerData.slug)"
            class="cas-link"
            :rel="
              $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
            "
            target="_blank"
            v-if="
              bonusPartnerData.bonus_match &&
              bonusPartnerData.exclusive_bonus_amount &&
              bonusPartnerData.exclusive_bonus_match
            "
            >{{ bonusPartnerData.exclusive_bonus_match }}%
            {{ $root.i18n.welcome_bonus }} {{ $root.i18n.up_to }}
            {{
              bonusPartnerData.exclusive_bonus_amount
                | currency(bonusPartnerData.bonus_currency)
            }}</a
          >
          <a
            :title="bonusPartnerData.product_name"
            :href="getGoLink(bonusPartnerData.go_link, bonusPartnerData.slug)"
            class="cas-link"
            :rel="
              $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
            "
            target="_blank"
            v-if="
              bonusPartnerData.bonus_match &&
              !bonusPartnerData.exclusive_bonus_amount &&
              bonusPartnerData.bonus_amount
            "
            >{{ bonusPartnerData.bonus_match }}% {{ $root.i18n.welcome_bonus }}
            {{ $root.i18n.up_to }}
            {{
              bonusPartnerData.bonus_amount
                | currency(bonusPartnerData.bonus_currency)
            }}</a
          >
          <a
            :title="bonusPartnerData.product_name"
            :href="getGoLink(bonusPartnerData.go_link, bonusPartnerData.slug)"
            class="cas-link"
            :rel="
              $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
            "
            target="_blank"
            v-if="
              bonusPartnerData.freespin &&
              bonusPartnerData.freebie_name &&
              !bonusPartnerData.exclusive_bonus_amount &&
              !bonusPartnerData.bonus_amount
            "
            >{{ bonusPartnerData.freespin }}
            {{ bonusPartnerData.freebie_name }}</a
          >
          <a
            :title="bonusPartnerData.product_name"
            :href="getGoLink(bonusPartnerData.go_link, bonusPartnerData.slug)"
            class="cas-link"
            :rel="
              $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
            "
            target="_blank"
            v-if="
              bonusPartnerData.bonus_amount &&
              !bonusPartnerData.bonus_match &&
              !bonusPartnerData.exclusive_bonus_amount &&
              !bonusPartnerData.freespin &&
              bonusPartnerData.freebie_name
            "
            >{{
              bonusPartnerData.bonus_amount
                | currency(bonusPartnerData.bonus_currency)
            }}
            {{ bonusPartnerData.bonus_name }}</a
          >
          <a
            :title="bonusPartnerData.product_name"
            :href="getGoLink(bonusPartnerData.go_link, bonusPartnerData.slug)"
            class="cas-link"
            :rel="
              $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
            "
            target="_blank"
            v-if="bonusPartnerData.freespin || bonusPartnerData.freebie_name"
          >
            <template
              v-if="
                (bonusPartnerData.exclusive_bonus_amount ||
                  bonusPartnerData.bonus_amount) &&
                bonusPartnerData.bonus_match
              "
              >+</template
            >
            <template v-if="bonusPartnerData.freespin">
              <template v-if="bonusPartnerData.show_freebie_currency === '1'">{{
                bonusPartnerData.freespin
                  | currency(bonusPartnerData.bonus_currency)
              }}</template>
              <template v-else>{{ bonusPartnerData.freespin }}</template>
              {{ bonusPartnerData.freebie_name }}
            </template>
            <template v-else>{{ bonusPartnerData.freebie_name }}</template>
          </a>
        </template>
      </span>
      <div class="deposit-heading" v-if="bonusData.make_first_deposit_to_claim">
        {{ bonusData.make_first_deposit_to_claim }}
      </div>
      <div class="bonus-info-box" v-if="!hideBonusLabelB">
        <h3>{{ $root.i18n.bonus_info }}</h3>
        <ul>
          <li
            v-if="
              (bonusPartnerData.bonus_match &&
                bonusPartnerData.exclusive_bonus_amount &&
                bonusPartnerData.exclusive_bonus_match) ||
              (bonusPartnerData.bonus_match &&
                !bonusPartnerData.exclusive_bonus_amount &&
                bonusPartnerData.bonus_amount)
            "
          >
            <span>{{ $root.i18n.welcome_bonus }}</span
            ><strong>
              <template
                v-if="
                  bonusPartnerData.bonus_match &&
                  bonusPartnerData.exclusive_bonus_amount &&
                  bonusPartnerData.exclusive_bonus_match
                "
                >{{ bonusPartnerData.exclusive_bonus_match }}%
                {{ $root.i18n.up_to }}
                {{
                  bonusPartnerData.exclusive_bonus_amount
                    | currency(bonusPartnerData.bonus_currency)
                }}
              </template>
              <template
                v-if="
                  bonusPartnerData.bonus_match &&
                  !bonusPartnerData.exclusive_bonus_amount &&
                  bonusPartnerData.bonus_amount
                "
                >{{ bonusPartnerData.bonus_match }}%
                {{ $root.i18n.up_to }}
                {{
                  bonusPartnerData.bonus_amount
                    | currency(bonusPartnerData.bonus_currency)
                }}</template
              >
            </strong>
          </li>
          <li v-if="bonusPartnerData.minimum_deposit">
            <span>{{ $root.i18n.min_deposit }}</span
            ><strong>{{
              bonusPartnerData.minimum_deposit
                | currency(bonusPartnerData.bonus_currency)
            }}</strong>
          </li>
          <li v-if="bonusPartnerData.freespin">
            <span>{{ $root.i18n.free_spins }} &nbsp;</span>
            <strong>
              <template v-if="bonusPartnerData.freespin">
                <template
                  v-if="bonusPartnerData.show_freebie_currency === '1'"
                  >{{
                    bonusPartnerData.freespin
                      | currency(bonusPartnerData.bonus_currency)
                  }}</template
                >
                <template v-else>{{ bonusPartnerData.freespin }}</template>
                {{ bonusPartnerData.freebie_name }}
              </template>
            </strong>
          </li>
          <li v-if="bonusPartnerData.bonus_amount">
            <span>{{ $root.i18n.max_bonus }}</span
            ><strong>{{
              bonusPartnerData.bonus_amount
                | currency(bonusPartnerData.bonus_currency)
            }}</strong>
          </li>
          <li v-if="bonusPartnerData.bonus_match">
            <span>{{ $root.i18n.match_bonus }}</span
            ><strong> {{ bonusPartnerData.bonus_match }}%</strong>
          </li>
          <!--<li>
            <span>{{ $root.i18n.wagering_requirements }}</span
            ><strong>6x</strong>
          </li>-->
        </ul>
      </div>
      <h3 v-if="!hideBonusLabelB">
        {{ $root.i18n.here_the_desciption_of_how_to_get_the_bonus }}
      </h3>
      <p v-if="bonusPartnerData.bonus_summary && !hideBonusLabelB">
        {{ bonusPartnerData.bonus_summary }}
      </p>
      <template v-if="bonusPartnerData.go_link && !hideBonusLabelB">
        <a
          :title="bonusPartnerData.product_name"
          :href="getGoLink(bonusPartnerData.go_link, bonusPartnerData.slug)"
          :class="{
            'cta cta-primary cta-promotion cta-block cta-promo-review custom-btn hover-btn cas-link ': true,
            'text-white game-btn':
              !$root.override_ctabtntxt_color &&
              !getContrastYIQ($root.color_schema.primary_btn),
            'text-gray':
              !$root.override_ctabtntxt_color &&
              getContrastYIQ($root.color_schema.primary_btn),
            'text-cta-override': $root.override_ctabtntxt_color,
          }"
          target="_blank"
          :rel="
            $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
          "
          :style="{
            '--primary-btn': $root.color_schema.primary_btn,
            '--primary-btn-hover': pSBC(-0.2, $root.color_schema.primary_btn),
          }"
          ><span class="cta-text">{{ bonusPartnerData.cta_button_text }}</span
          ><span
            class="hover-text"
            v-for="(char, indexGo) in $root.i18n.go_to_casino"
            :key="indexGo + `revspp`"
            >{{ char }}</span
          >
        </a>
      </template>
      <div
        class="terms"
        v-if="bonusPartnerData.bonus_tc && bonusPartnerData.bonus_tc != ''"
      >
        <!--<h6>{{ $root.i18n.terms___conditions_apply }}</h6>-->
        <span
          class="terms_tc cas-term rv-terms"
          v-if="bonusPartnerData.bonus_tc && bonusPartnerData.bonus_tc != ''"
          v-html="bonusPartnerData.bonus_tc"
          :style="{ '--primary-btn': $root.color_schema.primary_btn }"
        ></span>
        <span
          class="card-stroke"
          v-if="
            bonusPartnerData.bonus_tc &&
            bonusPartnerData.terms &&
            bonusPartnerData.bonus_tc != '' &&
            bonusPartnerData.terms != ''
          "
          >|</span
        >
        <a
          :rel="
            $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
          "
          class="terms_tc cas-term"
          v-if="bonusPartnerData.terms && bonusPartnerData.terms != ''"
          :title="bonusPartnerData.product_name"
          :href="getGoLink(bonusPartnerData.term_link, bonusPartnerData.slug)"
          target="_blank"
          >{{ bonusPartnerData.terms }}</a
        >
      </div>
    </div>
    <!-- bonus-information ends -->
  </div>
</template>
<script>
import { pSBC, getContrastYIQ, getOffset } from "@/misc/misc-function";
import currency from "@/misc/currency";

export default {
  name: "BonusInformation",
  props: [
    "bonusData",
    "bonusPartnerData",
    "assetsSize",
    "hideBonusLabelB",
    "bonusPrimaryColour",
  ],
  methods: {
    pSBC,
    getContrastYIQ,
    getOffset,
  },
  filters: {
    currency,
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/base/variable";
.bonus-info {
  .bonus-information {
    background: @white;
    .border-radius(12px);
    padding: 7px 12px 20px;
    max-width: 1014px;
    margin-bottom: 28px;
    @media (min-width: @sizes[small]) {
      padding: 29px 24px 32px;
      margin-bottom: 40px;
    }
    h1 {
      font-weight: bold;
      //text-transform: capitalize;
      color: #373a3c;
      margin-bottom: 14px;
      @media (min-width: @sizes[large]) {
        margin-bottom: 26px;
      }
    }
    h2 {
      //text-transform: capitalize;
    }
    .cas-logo {
      .display-flex();
      .align-items(center);
      .justify-content-center();
      .border-radius(5px);
      margin-bottom: 12px;
      @media (min-width: @sizes[small]) {
        margin-bottom: 24px;
      }
      a {
        width: 100%;
      }
      img {
        width: 100%;
        height: 155px;
        border-radius: 5px;
        margin: 0;
        object-fit: contain;
      }
    }
    .bonus-text {
      font-weight: bold;
      font-size: 18px;
      line-height: 27px;
      //text-transform: capitalize;
      color: #373a3c;
      margin-bottom: 9px;
      display: block;
      @media (min-width: @sizes[small]) {
        font-size: 28px;
        line-height: 34px;
        margin-bottom: 12px;
      }
      @media (min-width: @sizes[large]) {
        font-size: 32px;
        line-height: 39px;
        margin-bottom: 5px;
      }
    }
    .deposit-heading {
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      //text-transform: capitalize;
      color: #4d4d4d;
      margin-bottom: 12px;
      @media (min-width: @sizes[large]) {
        font-size: 20px;
        line-height: 30px;
      }
    }
    h3 {
      font-weight: bold;
      //text-transform: capitalize;
      color: #373a3c;
      margin-bottom: 12px;
      @media (min-width: @sizes[large]) {
        margin-bottom: 6px;
      }
    }
    p {
      font-weight: normal;
      //text-transform: capitalize;
      color: #4d4d4d;
      margin-bottom: 15px;
    }
    .cta-primary {
      font-weight: bold;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0.02em;
      //.border-radius(100px);
      padding: 14px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      @media (min-width: @sizes[large]) {
        font-size: 18px;
        line-height: 18px;
        padding: 16px 20px;
      }
    }
    .terms {
      margin-top: 11px;
      display: block;
      @media (min-width: @sizes[small]) {
        display: block;
      }
      @media (min-width: @sizes[large]) {
        margin-top: 14px;
      }
      h6,
      a {
        font-weight: normal;
        font-size: 16px;
        line-height: 160%;
        text-decoration-line: underline;
        text-transform: uppercase;
        color: #9a9a9a;
        display: inline-block;
        margin-bottom: 7;
      }
      p {
        font-weight: normal;
        text-align: justify;
        color: #9a9a9a;
        margin-bottom: 0;
      }
    }
  }
  .bonus-info-box {
    background: #f7f7f7;
    .border-radius(5px);
    padding: 24px 24px 28px;
    margin-bottom: 17px;
    ul {
      list-style: none;
      margin: 0px;
      padding: 0;
      -webkit-column-count: unset;
      -moz-column-count: unset;
      column-count: unset;
      @media (min-width: @sizes[small]) {
        -webkit-column-count: 2;
        -moz-column-count: 2;
        column-count: 2;
        margin: 0 -25px;
      }
      li {
        position: static;
        border-bottom: 1px solid #d7d9da;
        padding: 0;
        margin: 0px;
        .display-flex();
        .align-items(center);
        .justify-content-space-between();
        font-size: 13px;
        line-height: 32px;
        @media (min-width: @sizes[small]) {
          margin: 0px 25px;
          font-size: 16px;
          line-height: 34px;
          min-height: 46px;
        }
        @media (min-width: @sizes[large]) {
          font-size: 18px;
          line-height: 44px;
        }
        @media (max-width: @sizes[small]) {
          line-height: 13px !important;
          padding: 9px 0 !important;
        }
        span {
          font-weight: normal;
          color: #4d4d4d;
          @media (max-width: @sizes[small]) {
            flex: 0 0 auto;
          }
        }
        strong {
          font-weight: bold;
          text-align: right;
          letter-spacing: 0.02em;
          color: #4d4d4d;
          @media (max-width: @sizes[small]) {
            line-height: 16px;
            flex: 1 1 auto;
          }
        }
        &:before {
          background: none !important;
        }
      }
    }
  }
}

.bonus-info .bonus-information .cas-logo img {
  @media (min-width: @sizes[large]) {
    width: auto;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .bonus-info .bonus-info-box ul li {
    display: block;
  }
  .bonus-info .bonus-info-box ul li strong {
    float: right;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/custom-block/BonusInformation.vue